import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";
import { mapSellingProductToServer } from "./mappers/mapSellingProductToServer";

export const removeProductFromSelling = async (sessionKey, product) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/remove/product`,
            method: "DELETE",
            data: mapSellingProductToServer(product),
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
